"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.search");
require("core-js/modules/es6.number.constructor");
var _goods_promotion = require("@/api/goods_activity/goods_promotion");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GoodsPromotionTablePane',
  components: {},
  props: {
    goodsPromotionType: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      tableKey: 0,
      listQuery: {
        goodsPromotionType: this.goodsPromotionType,
        page: 1,
        limit: 20,
        keywords: ''
      },
      multipleSelection: [],
      importDialogVisible: false,
      importLoading: false,
      fileList: []
    };
  },
  created: function created() {
    this.search();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    batchConfig: function batchConfig() {
      this.$emit('toConfig', this.multipleSelection);
    },
    handleEdit: function handleEdit(item) {
      this.$emit('toEdit', item);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleFilter: function handleFilter() {
      var _this = this;
      this.loading = true;
      (0, _goods_promotion.queryGoodsPromotionPage)(this.listQuery).then(function (res) {
        _this.tableData = res.records;
        _this.total = res.total;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    // 切换促销开关状态
    togglePromotion: function togglePromotion(row) {
      var _this2 = this;
      // 检查是否有促销时间
      if (row.startDateStr && row.endDateStr) {
        // 有促销时间，直接切换状态
        var updateData = {
          id: row.goodsPromotionFnId,
          markForEnable: !row.markForEnable
        };
        (0, _goods_promotion.updEnable)(updateData).then(function (res) {
          _this2.$message({
            message: row.markForEnable ? '已关闭促销' : '已开启促销',
            type: 'success'
          });
          // 刷新列表
          _this2.search();
        });
      } else {
        // 没有促销时间，进入编辑页
        this.$emit('toEdit', row);
      }
    },
    // 显示导入对话框
    showImportDialog: function showImportDialog() {
      this.importDialogVisible = true;
      this.fileList = [];
    },
    // 文件改变事件
    handleFileChange: function handleFileChange(file, fileList) {
      this.fileList = fileList;
    },
    // 文件超出限制
    handleExceed: function handleExceed() {
      this.$message.warning('只能上传一个文件');
    },
    // 下载模板
    downloadTemplate: function downloadTemplate() {
      var _this3 = this;
      (0, _goods_promotion.downloadGoodsPromotionTemplate)().then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '商品促销导入模板.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
        _this3.$message.success('导入模板下载成功');
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this3.$message.error('下载失败');
      });
    },
    // 处理导入
    handleImport: function handleImport() {
      var _this4 = this;
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      var file = this.fileList[0].raw;
      var formData = new FormData();
      formData.append('file', file);
      this.importLoading = true;
      (0, _goods_promotion.importGoodsPromotion)(formData).then(function (res) {
        _this4.$message({
          message: res.msg || '导入成功',
          type: 'success'
        });
        _this4.importDialogVisible = false;
        _this4.fileList = [];
        _this4.search();
      }).catch(function (err) {
        _this4.$message({
          message: err.msg || '导入失败',
          type: 'error'
        });
      }).finally(function () {
        _this4.importLoading = false;
      });
    }
  }
};